<template>
  <div id="storeManage">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="90px">

              <el-form-item :label="$t('filters.region')" >
                <el-select v-model="filterForm.regionNos" multiple :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in regionOptions"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.province')" >
                <el-select v-model="filterForm.provinceNos" multiple :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.city')" >
                <el-select v-model="filterForm.cityNos" multiple :placeholder="$t('filters.chooseCity')" @visible-change="getRangeList()">
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.reseller')" >
                <el-select v-model="filterForm.resellerNos" multiple :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in resellerOptions"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.doorName')" >
                <span @click="onChooseDoor">
                  <el-input v-model="filterForm.door" :placeholder="$t('filters.chooseDoorName')"></el-input>
                </span>
              </el-form-item>
              <el-form-item label="门店编号">
                <el-input v-model="filterForm.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
              </el-form-item>

              <el-form-item :label="$t('topdoor.importTime')" >
                <el-date-picker
                  v-model="filterForm.dateRange"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                  align="right">
                </el-date-picker>
              </el-form-item>

            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="24">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="IMPORTDATA">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
            <p class="operations">
              <el-button type="primary" @click="$refs.importFile.click()">{{ $t('topdoor.importDoor') }}</el-button>
              <input type="file" ref="importFile" @change="importExcel" v-show="false"/>

              <el-button type="text" style="margin-left: 20px" @click="downloadTemplate"><i
                class="el-icon-info"></i>{{ $t('store.downloadTemplate') }}</el-button>
            </p>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
            >
              <el-table-column
                fixed
                prop="doorName"
                :label="$t('filters.doorName')"
                width="300"
              >
              </el-table-column>
              <el-table-column
                prop="posId"
                label="门店编号">
              </el-table-column>
              <el-table-column
                prop="regionName"
                :label="$t('filters.region')"
              >
              </el-table-column>
              <el-table-column
                prop="provinceName"
                :label="$t('filters.province')"
              >
              </el-table-column>
              <el-table-column
                prop="cityName"
                :label="$t('filters.city')"
              >
              </el-table-column>
              <el-table-column
                prop="resellerName"
                :label="$t('filters.reseller')"
              >
              </el-table-column>
              <el-table-column
                prop="importTime"
                :label="$t('topdoor.importTime')"
                width="180"
              >
              </el-table-column>
              <el-table-column
                :label="$t('operation')"
                width="100">
                <template slot-scope="scope">
                  <router-link :to=" { path:'/topdoor/topdoor/storeEdit', query:{ doorNo: scope.row.doorNo} }" target="_blank" >
                    <el-button type="text" size="small">{{ $t('edit') }}</el-button>
                  </router-link>
<!--                  <el-button @click="onDelete(scope.row.doorNo)" type="text" size="small">{{ $t('delete') }}</el-button>-->
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <pickDoor v-model="filterForm.posId" :filterForm="this.filterForm" ref='PickDoor'/>
  </div>
</template>

<script>
import _ from 'lodash'
import PickDoor from "../../components/pickTopDoor";
import Cookies from 'js-cookie'

export default {
  name: 'TaskManage',
  components: {
    pickDoor: PickDoor,
  },
  data: function () {
    return {
      statusOptions: [],
      taskListData: [],
      currentPosId: '', //
      rateData: [], // 占比统计表格的数据
      curDoorName: '', // 当前占比统计的门店名称
      rateDialogVisible: false, //占比统计弹窗
      taskListDialogVisible: false, // 任务列表
      systemOptions: [
      ],
      taskListFilterForm: {}, // 任务列表的筛选条件
      initTaskListFilterForm: {
        systemType: '',
        status: ''
      },
      filterForm: {
        dateRange: [], // 时间范围
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        regionNos: [],
        provinceNos: [],
        cityNos: [],
        clusterName: '',
        concept: '',
        clusterGroup: '',
        tzGroup: '',
        format: '',
        resellerNos: [],
        subReseller: '',
        hubDoor: '',
        doorName: '',
        posId: '',
      },
      initFilterForm: {
        dateRange: '', // 时间范围
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        regionNos: [],
        provinceNos: [],
        cityNos: [],
        clusterName: '',
        concept: '',
        clusterGroup: '',
        tzGroup: '',
        format: '',
        resellerNos: [],
        subReseller: '',
        hubDoor: '',
        doorName: '',
        posId: '',
      },
      tableData: [], // 表格数据
      total: 0,
      totalTaskList: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableConfigTaskList: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      taskTableLoading: false,
      regionOptions: [
      ],
      provinceOptions: [
      ],
      cityOptions: [
      ],
      clusterNameOptions: [
      ],
      conceptOptions: [
      ],
      cityTierOptions: [
      ],
      tzGroupOptions: [
      ],
      formatOptions: [
      ],
      resellerOptions: [
      ],
      subResellerOptions: [
      ],
      hubDoorOptions: [
      ],
      todoTotal: 0,
      todoCompletions: 0,
      completionRate: 0,
      chart1: null,
    }
  },
  mounted () {
    this.getRangeList()
    this.onReset()
  },

  methods: {

    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },
    resetFilters: function () {
      this.getRangeList()
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'cityNos': this.filterForm.cityNos,
        'resellerNos': this.filterForm.resellerNos,
        'provinceNos': this.filterForm.provinceNos,
        'regionNos': this.filterForm.regionNos,
      }
      let submitParams = filterParams
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(topdoorReqUrl + '/door/ganged', submitParams)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = res.regions
      this.provinceOptions = res.provinces
      this.cityOptions = res.cities
      this.resellerOptions = res.resellers
    },

    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    seeDetail() {
      // todo: 查看
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },

    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let submitParams = this.filterForm
      console.log('submitParams', submitParams)
      submitParams.startTime = submitParams.dateRange ? submitParams.dateRange[0] : ''
      submitParams.endTime = submitParams.dateRange ? submitParams.dateRange[1] : ''
      let res = await window.instance.post(topdoorReqUrl + '/door/list', _.assign(submitParams, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.doors
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },

    async importExcel({ target }) {
      let formData = new FormData();
      formData.append("file", target.files[0]);
      let res = await window.instance.post(topdoorReqUrl + "/door/importDoor", formData);
      if(res.data.code === 200) this.$message.success("导入成功！");
      else this.$message.error("导入失败！");
    },


    // 下载模板
    downloadTemplate: async function () {
      let response = await window.instance({
        method: "post",
        responseType: "blob",
        url: topdoorReqUrl + '/door/template',
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]||''
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    },

    onDelete: async function(doorNo){
      const confirmTip = this.$t('topdoor.deleteDoor')+'?'
      const tip = this.$t('tip')
      this.$confirm(confirmTip, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(async () => {
          try{
            let res = await window.instance.post(topdoorReqUrl + "/door/delete/" + doorNo)
            res = res.data
            console.log('res....', res)
            console.log('code....', res.code)
            if (res.code === 200) {
              this.$message.success(res.message)
              await this.onSearch()
            }
          }catch(error){
            console.error('删除失败:', error)
          }
        })
        .catch(error => {
          console.error('删除请求失败:', error)
        })
    }


  }
}
</script>

<style scoped lang="sass">
.operations
  float: right
  color: #ff6801
  font-size: 14px
  margin: -30px 0 0 90px
  span
    margin-right: 20px
#storeManage

</style>



// WEBPACK FOOTER //
// src/topdoor/pages/topdoor/storeManage.vue